import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import HelperComponent from '../../components/HelperComponent/HelperComponent';
import DeletePrompt from '../../components/Propmts/deletePrompt';
import { ERRORS } from '../../constants/AppConstants';
import { deleteWebsite as deleteWebSite } from '../../services/websitesService';


const WebsitesAndSetup = () => {
    
    const history = useHistory();
    const [ openWebsites, setOpenWebsites ] = useState([]);

    const {websites, deleteWebsite, setIsBgDisabled, planDetails, defaultWebsite} = useAppContext();

    const [deletePrompt, setDeletePrompt] = useState(false);
    const [selectedWebsite, setSelectedWebsite] = useState(null);

    const accordionHandler = (index) => {
        const temp = [...openWebsites];
        const isCurrentOpen = temp.indexOf(index);
        if(isCurrentOpen >= 0) {
            temp.splice(isCurrentOpen, 1);
        } else {
            temp.push(index);
        }
        setOpenWebsites(temp);
    }

    const edit = (website, pathName) => {
        history.push({
            pathname: pathName,
            state: website
        })
    }

    const deleteWeb = useMutation((website) => {
        return deleteWebSite(website.id)
    }, {
        onSuccess: ((webSiteData,variables) => {
            if(webSiteData.errors) {
                toast.error(ERRORS[webSiteData.errors.website])
            } else {
                toast.success('Website deleted successfully');
                setSelectedWebsite(null);
                deleteWebsite(variables.id);      
            }
        //    setOpenDialogue(false);
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });


    const delWebsite = (website) => {
        const websiteId = website?.id;
        if(websiteId === defaultWebsite?.id) {
            toast.error('Sorry!!, You cannot delete primary website.')
        }
        if(websiteId === selectedWebsite?.id) {
            toast.error('Sorry!!, You cannot delete current selected website.')
        } else {
            setSelectedWebsite(website);
            setDeletePrompt(true);
            setIsBgDisabled(true);
        }
        
    }
    
    const onDelete = (event) => {
        event.preventDefault();
        setDeletePrompt(false);
        setIsBgDisabled(false);
        deleteWeb.mutate(selectedWebsite);
    }

    const onCancel = () =>{
        setDeletePrompt(false); 
        setIsBgDisabled(false);
        setSelectedWebsite(null);
    }

    const addWebsite = () => {
        const ownerWebsites = websites.filter(({user_type}) => user_type === 'owner');
        if(ownerWebsites?.length >= planDetails?.website_thresholds) {
            toast.error('You have crossed website limit of your plan, please upgrade for adding more websites');
        } else {
            history.push('/add-website')
        }
    }

    return <>
        { deletePrompt && <DeletePrompt onDelete={onDelete} onCancel={onCancel} />}

        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">
                        Websites &amp; Setup
                        <HelperComponent
                            component={'Websites & Setup'}  
                            href="https://chirpyweb.com/documentation_posts/website-setup/" />
                    </h3>
                
                    <button className="btn btn-primary" onClick={() => addWebsite() } >
                        <i className="icon icon-add"></i> Add New Website
                    </button>
                </div>                                
            </div>
            <div className="panel-body scrollable_y">
                <div className="masonary-wrapper">
                    {
                        websites.map((website, index) =>   <div className="" key={`1_${index}`}>
                        <div className="accordion">
                            <div onClick={() => accordionHandler(website.id)} className="accordion-title d-flex justify-content-between">
                                <div className="media">
                                    <div className="media_figure media-rounded">
                                        {/* Add image Tah */}
                                        {/* <h3 className="abbr">C</h3> */}
                                        <img src={`${website.logo}?${new Date().getTime()}`} style={{height:'40px'}} />
                                    </div>
                                    <div className="media_body">
                                        <h6 className="website-title mb-0">{website.title}</h6>
                                        <p className="text-light">{website.url}</p>
                                    </div>
                                </div>
                                <button className="btn btn-neutral" >
                                    <i className={ openWebsites.includes(website.id) ? 'increment-icon default' : 'decrement-icon default' }></i>
                                </button>
                            </div>
                        { openWebsites.includes(website.id) && <div className="accordion-body">
                                    {/* <div className="data-list mb-4 px-3">
                                        <div className="data-list-item">
                                            <div className="data-label">Agent:</div>
                                            <div className="data-description">Jenny Wilson</div>
                                        </div>      
                                        <div className="data-list-item">
                                            <div className="data-label">Invited:</div>
                                            <div className="data-description">Ralph Edwards</div>
                                        </div>      
                                        <div className="data-list-item">
                                            <div className="data-label">RSS Feed:</div>
                                            <div className="data-description">50</div>
                                        </div>                                                    
                                    </div> */}
                                <div className="d-flex flex-wrap justify-content-between action-buttons px-3">
                                    {
                                        website.role !== 'view' && <button className="btn btn-primary" onClick={() => history.push('/rss-setup')}>
                                                <i className="icon icon-feed"></i> Add Rss Feed
                                            </button>
                                        }
                                    {   website.user_type === 'owner' && <button className="btn btn-outline"  onClick={() => edit(website, '/change-icon')} >
                                            <i className="icon icon-profile"></i> Change Icon
                                        </button>
                                    }
                                    {   website.user_type === 'owner' && <button onClick={() => edit(website, '/edit-website')} className="btn btn-outline">
                                            <i className="icon icon-edit" ></i> Edit
                                        </button>
                                    }
                                    {   website.user_type === 'owner' &&  <button className="btn btn-danger" onClick={ ()=> delWebsite(website)} >
                                            <i className="icon icon-delete"></i> Delete
                                        </button>
                                    }
                                </div>
                                <div className="d-flex flex-column">
                                    <div className="box d-flex justify-content-between">
                                        <span>Subscribers</span>
                                        <span>{website.subscriber_count}</span>
                                    </div>
                                    <div className="box d-flex justify-content-between">
                                        <span>Role</span>
                                        <span style={{textTransform: 'capitalize'}}>{website.user_type} {website.user_type === 'agent' && `(${website.role})`}</span>
                                    </div>
                                </div>
                            </div>
                            }                    
                        </div>
                    </div>
                        
                        )
                    }
                </div>
            </div>
        </div>

    </>
}
export default WebsitesAndSetup;